<template>
  <BaseWorkPageLayout :title="$t('global.documents')" icon="file">
    <template #cta>
      <div class="w-72 max-sm:w-full">
        <BaseSearchInput
          v-model="searchTerm"
          :placeholder="$t('global.search')"
        />
      </div>
    </template>
    <template #default>
      <div
        v-if="filteredDocuments.length"
        class="grid grid-cols-1 gap-4 sm:grid-cols-2"
      >
        <WorkDocumentCard
          v-for="document in filteredDocuments"
          :key="document.id"
          :document="document"
        />
      </div>
      <div v-else class="py-10 text-center text-gray-500 italic">
        {{ $t('global.no_result_found') }}
      </div>
    </template>
  </BaseWorkPageLayout>
</template>

<script>
import WorkDocumentCard from './components/WorkDocumentCard.vue'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheWorkDocumentsPage',
  components: { WorkDocumentCard },
  computed: {
    ...mapGetters({
      work: 'work/getWork',
      documents: 'document/getDocuments'
    }),
    filteredDocuments() {
      const term = this.$h.normalizeSearch(this.searchTerm ?? '')
      return (this.documents ?? []).filter(
        (document) =>
          !term ||
          this.$h.normalizeSearch(document.name ?? '').includes(term) ||
          this.$h.normalizeSearch(document.description ?? '').includes(term)
      )
    }
  },
  data() {
    return { searchTerm: '' }
  },
  methods: {
    ...mapActions('document', ['fetchDocumentsList'])
  },
  mounted() {
    this.fetchDocumentsList()
  }
}
</script>
